export default __webpack_public_path__ + "static/media/related-image-02.cda48b81.jpg";